import { render, staticRenderFns } from "./ManageGroups.vue?vue&type=template&id=490cdd0b&scoped=true&lang=pug"
import script from "./ManageGroups.vue?vue&type=script&lang=js"
export * from "./ManageGroups.vue?vue&type=script&lang=js"
import style0 from "./ManageGroups.vue?vue&type=style&index=0&id=490cdd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490cdd0b",
  null
  
)

export default component.exports